module.exports = __webpack_public_path__ + "static/img/excel.3cd232bf.png";